<template>
    <div
        class="ppv2-border ppv2-border-dashed ppv2-border-[#dcdcdc] ppv2-border-opacity-50 ppv2-flex ppv2-flex-col ppv2-relative ppv2-rounded-[12px]"
        :class="[{ '!ppv2-border-[#021832]': !isDark }, customClass]"
        :style="{
            marginTop: marginTop ? normalizeSizeVertical(marginTop, true) : 0,
            marginBottom: marginBottom > 0 ? normalizeSizeVertical(marginBottom, true) : 0,
            ...(minHeight ? { minHeight: minHeight } : {}),
            ...customStyle,
        }"
    >
        <!-- 🏷️ Titre flottant -->

        <div
            v-if="!title"
            class="poppinsLight ppv2-mx-[10px] ppv2-text-black ppv2-px-1 ppv2-absolute ppv2-top-[-10px] ppv2-left-0 ppv2-bg-white dark:ppv2-bg-dark ppv2-truncate"
            :class="customClassTitle"
            :style="{ fontSize: normalizeFontSize(titleSize, true) }"
        >
            <slot name="title"></slot>
        </div>
        <h4
            v-else
            class="poppinsLight ppv2-mx-[10px] ppv2-px-1 ppv2-absolute ppv2-top-[-12px] ppv2-truncate"
            :style="{ fontSize: normalizeFontSize(titleSize, true) }"
            :class="[{ ' dark:ppv2-bg-dark ppv2-bg-white ppv2-text-black': !titleHasBg }, titleHasBg, customClassTitle]"
        >
            {{ title }}
        </h4>

        <!-- 📦 Contenu -->
        <slot name="content"></slot>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import normalizeSizeVertical from '../../utils/normalizeSizeVertical'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'DashedCard',
    data() {
        return {}
    },
    props: {
        title: { type: String },
        titleSize: { type: Number, default: 15 },
        minHeight: { type: String, default: null },
        marginBottom: { type: Number, default: 40 },
        marginTop: { type: Number, default: null },
        customClass: { type: [String, Array], default: '' },
        customClassTitle: { type: String, default: '' },
        titleHasBg: { type: String, default: '' },
        customStyle: { type: Object, default: () => ({}) },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        normalizeSizeVertical,
    },
    computed: {
        isDark() {
            return this.theme.mode === 'dark'
        },
    },
    watch: {},
}
</script>
